function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { position, stopAndPrevent } from '../../utils/event.js';
import { between, normalizeToInterval } from '../../utils/format.js';
import { slot } from '../../utils/slot.js';
import cache from '../../utils/cache.js';
import QCircularProgress from '../circular-progress/QCircularProgress.js';
import FormMixin from '../../mixins/form.js';
import TouchPan from '../../directives/TouchPan.js'; // PGDOWN, LEFT, DOWN, PGUP, RIGHT, UP

var keyCodes = [34, 37, 40, 33, 39, 38];
export default Vue.extend({
  name: 'QKnob',
  mixins: [{
    props: QCircularProgress.options.props
  }, FormMixin],
  directives: {
    TouchPan: TouchPan
  },
  props: {
    innerMin: Number,
    innerMax: Number,
    step: {
      type: Number,
      "default": 1,
      validator: function validator(v) {
        return v >= 0;
      }
    },
    tabindex: {
      type: [Number, String],
      "default": 0
    },
    disable: Boolean,
    readonly: Boolean
  },
  data: function data() {
    var innerMin = this.__getInnerMin(this.innerMin);

    var innerMax = this.__getInnerMax(this.innerMax);

    return {
      model: this.value === null ? innerMin : between(this.value, innerMin, innerMax),
      dragging: false
    };
  },
  watch: {
    modelUpdate: function modelUpdate() {
      this.model = this.value === null ? this.computedInnerMin : between(this.value, this.computedInnerMin, this.computedInnerMax);

      this.__updateValue(true);
    }
  },
  computed: {
    classes: function classes() {
      return 'q-knob non-selectable' + (this.editable === true ? ' q-knob--editable' : this.disable === true ? ' disabled' : '');
    },
    computedInnerMin: function computedInnerMin() {
      return this.__getInnerMin(this.innerMin);
    },
    computedInnerMax: function computedInnerMax() {
      return this.__getInnerMax(this.innerMax);
    },
    modelUpdate: function modelUpdate() {
      return "".concat(this.value, "|").concat(this.computedInnerMin, "|").concat(this.computedInnerMax);
    },
    editable: function editable() {
      return this.disable === false && this.readonly === false;
    },
    decimals: function decimals() {
      return (String(this.step).trim('0').split('.')[1] || '').length;
    },
    computedStep: function computedStep() {
      return this.step === 0 ? 1 : this.step;
    },
    computedInstantFeedback: function computedInstantFeedback() {
      return this.instantFeedback === true || this.dragging === true;
    },
    onEvents: function onEvents() {
      return this.$q.platform.is.mobile === true ? {
        click: this.__click
      } : {
        mousedown: this.__activate,
        click: this.__click,
        keydown: this.__keydown,
        keyup: this.__keyup
      };
    },
    attrs: function attrs() {
      var attrs = {
        role: 'slider',
        'aria-valuemin': this.computedInnerMin,
        'aria-valuemax': this.computedInnerMax,
        'aria-valuenow': this.value
      };

      if (this.editable === true) {
        attrs.tabindex = this.tabindex;
      } else {
        attrs["aria-".concat(this.disable === true ? 'disabled' : 'readonly')] = '';
      }

      return attrs;
    }
  },
  methods: {
    __getInnerMin: function __getInnerMin(val) {
      return isNaN(val) === true || this.innerMin < this.min ? this.min : this.innerMin;
    },
    __getInnerMax: function __getInnerMax(val) {
      return isNaN(val) === true || val > this.max ? this.max : this.innerMax;
    },
    __updateCenterPosition: function __updateCenterPosition() {
      var _this$$el$getBounding = this.$el.getBoundingClientRect(),
          top = _this$$el$getBounding.top,
          left = _this$$el$getBounding.left,
          width = _this$$el$getBounding.width,
          height = _this$$el$getBounding.height;

      this.centerPosition = {
        top: top + height / 2,
        left: left + width / 2
      };
    },
    __pan: function __pan(event) {
      if (event.isFinal) {
        this.__updatePosition(event.evt, true);

        this.dragging = false;
      } else if (event.isFirst) {
        this.__updateCenterPosition();

        this.dragging = true;

        this.__updatePosition(event.evt);
      } else {
        this.__updatePosition(event.evt);
      }
    },
    __click: function __click(evt) {
      this.__updateCenterPosition();

      this.__updatePosition(evt, true);
    },
    __keydown: function __keydown(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }

      stopAndPrevent(evt);
      var step = ([34, 33].includes(evt.keyCode) ? 10 : 1) * this.computedStep,
          offset = [34, 37, 40].includes(evt.keyCode) ? -step : step;
      this.model = between(parseFloat((this.model + offset).toFixed(this.decimals)), this.computedInnerMin, this.computedInnerMax);

      this.__updateValue();
    },
    __keyup: function __keyup(evt) {
      if (keyCodes.includes(evt.keyCode)) {
        this.__updateValue(true);
      }
    },
    __activate: function __activate(evt) {
      this.__updateCenterPosition();

      this.__updatePosition(evt);
    },
    __updatePosition: function __updatePosition(evt, change) {
      var center = this.centerPosition,
          pos = position(evt),
          height = Math.abs(pos.top - center.top),
          distance = Math.sqrt(Math.pow(height, 2) + Math.pow(Math.abs(pos.left - center.left), 2));
      var angle = Math.asin(height / distance) * (180 / Math.PI);

      if (pos.top < center.top) {
        angle = center.left < pos.left ? 90 - angle : 270 + angle;
      } else {
        angle = center.left < pos.left ? angle + 90 : 270 - angle;
      }

      if (this.$q.lang.rtl === true) {
        angle = normalizeToInterval(-angle - this.angle, 0, 360);
      } else if (this.angle) {
        angle = normalizeToInterval(angle - this.angle, 0, 360);
      }

      if (this.reverse === true) {
        angle = 360 - angle;
      }

      var model = this.min + angle / 360 * (this.max - this.min);

      if (this.step !== 0) {
        var step = this.computedStep,
            modulo = model % step;
        model = model - modulo + (Math.abs(modulo) >= step / 2 ? (modulo < 0 ? -1 : 1) * step : 0);
        model = parseFloat(model.toFixed(this.decimals));
      }

      model = between(model, this.computedInnerMin, this.computedInnerMax);
      this.$emit('drag-value', model);

      if (this.model !== model) {
        this.model = model;
      }

      this.__updateValue(change);
    },
    __updateValue: function __updateValue(change) {
      this.value !== this.model && this.$emit('input', this.model);
      change === true && this.$emit('change', this.model);
    },
    __getNameInput: function __getNameInput() {
      return this.$createElement('input', {
        attrs: this.formAttrs
      });
    }
  },
  render: function render(h) {
    var data = {
      "class": this.classes,
      attrs: this.attrs,
      props: _objectSpread(_objectSpread({}, this.$props), {}, {
        value: this.model,
        instantFeedback: this.computedInstantFeedback
      })
    };

    if (this.editable === true) {
      data.on = this.onEvents;
      data.directives = cache(this, 'dir', [{
        name: 'touch-pan',
        value: this.__pan,
        modifiers: {
          prevent: true,
          stop: true,
          mouse: true
        }
      }]);

      if (this.name !== void 0) {
        data.scopedSlots = {
          internal: this.__getNameInput
        };
      }
    }

    return h(QCircularProgress, data, slot(this, 'default'));
  }
});